import {BmFilterIcon} from "~/components/icons/simpleIcons";

import {BmWhiteButton, BmWhiteButtonProps} from "../WhiteButton";

export const BmFilteringButton: React.FC<BmWhiteButtonProps> = ({...props}) => {
  return (
    <BmWhiteButton
      sx={{
        "&.MuiButton-root": {
          minWidth: "42px",
          p: "0!important",
        },
      }}
      {...props}
    >
      <BmFilterIcon id="filter-button-icon" size="sm" />
    </BmWhiteButton>
  );
};
